<span>
  @if (this.result && this.result.contextClass && this.result.placeChange) {
    <span class="results-table-place-change-container {{ result.contextClass }}">
      <fa-icon [icon]="environment.placeChangeIcons[result.contextClass]"></fa-icon>
      {{ result.placeChange.toString().replace('-', '') }}&nbsp;
    </span>
  }
  <span [innerHTML]="frontStatLine"></span>
  <span [innerHTML]="middleStatLine"> </span>
</span>
